import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Button,
  Modal,
  Form,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"
import Inoculation from "../../assets/images/inoculation.png"
import axios from "axios"
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

import "./datatables.scss"

const DatatableTables = props => {
  document.title = "Process Master | My Urban Farms "

  const breadcrumbItems = []

  const [modal_center, setmodal_center] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)
  const [selectedProcess, setSelectedProcess] = useState(null)
  const [processDays, setProcessDays] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [editingItem, setEditingItem] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [rows, setRows] = useState([]);
  const [oldImagePath, setOldImagePath] = useState(null);

  const [farmList, setFarmList] = useState([])

  const [selectedFarmKey, setSelectedFarmKey] = useState("");




  useEffect(() => {

      fetchProcessesDays();
  
  }, []);

  const fetchProcessesDays = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllProcessdays/process/`
      );
      const resData = response.data;
      setIsLoading(false);

      if (resData.message?.success && Array.isArray(resData.message.data)) {
        setProcessDays(resData.message.data);
      } else {
        console.warn("Unexpected data format", resData);
      }
    } catch (error) {
      console.error("Failed to fetch batch list:", error);
      setIsLoading(false);
    }
  };

  const fetchProcess = async (selectedFarmKey) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllProcess/process/`,
        { farmKey: selectedFarmKey }
      );
      const res = response.data;
      if (res?.message?.success && Array.isArray(res.message.data)) {

        const mapped = res.message.data.map((item, idx) => ({
          id: idx + 1,
          sno: `${idx + 1}`,
          "Process Name": item.process_name || "-",
          Description: item.process_description || "-",
          "Process Image": item.process_image
            ? <img src={`${process.env.REACT_APP_IMAGE_URL}${item.process_image}`} alt={item.process_name} width="80" />
            : "-",
          // Duration: item.process_duration || "-",
          Day: item.process_day || "-",
          pk_process_key: item.pk_process_key || item.pk_process_key,
        }));
        setRows(mapped);
      }
    } catch (err) {
      console.error("Failed to fetch processes:", err);
    }
  };

  const toggleDropdown = id => {
    setOpenDropdown(openDropdown === id ? null : id)
  }

  function tog_center() {
    if (!modal_center) {
      setEditingItem(null);
      setImagePreview(null);
      formik.resetForm();
    }
    setmodal_center(!modal_center)
  }

  const toggleEditModal = process => {
    setSelectedProcess(process)
    setEditModal(!editModal)
  }

  useEffect(() => {
    props.setBreadcrumbItems("Process Master", breadcrumbItems)
    fetchFarms();

  }, [])

  const adminKey = sessionStorage.getItem("pk_admin_key") || "";


  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      // duration: "",
      image: null,
      day: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      description: Yup.string().required("Description is required"),
      // duration: Yup.string().required("Duration is required"),
      day: Yup.string().required("Please select a day"),
      image: Yup.mixed().nullable(),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("process_name", values.title);
      formData.append("process_description", values.description);
      formData.append("process_duration", values.duration);
      formData.append("process_day", values.day);
      formData.append("status", 1);
      formData.append("created_by", adminKey);
      formData.append("fk_farm_key", selectedFarmKey);

      if (editingItem) {

        // CASE 1: user removed image
        if (!imagePreview && !values.image) {
          formData.append("process_image", "");
        }

        // CASE 2: user kept old image (no new upload)
        else if (oldImagePath && !values.image) {
          formData.append("existing_image", oldImagePath);
        }

        // CASE 3: user uploaded a new file
        else if (values.image instanceof File) {
          formData.append("process_image", values.image);
        }

      } else {
        // fresh add
        if (values.image instanceof File) {
          formData.append("process_image", values.image);
        }
      }

      try {
        let response;

        if (editingItem) {
          // Update
          formData.append("pk_process_key", editingItem.pk_process_key);
          response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/updateProcess/process/`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          toast.success("Updated successfully!", { autoClose: 3000 });
        } else {
          // Add
          response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/addProcess/process/`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          toast.success("Added successfully!", { autoClose: 3000 });
        }

        fetchProcess(selectedFarmKey);
        closeModal();
      } catch (error) {
        console.error("Error saving data:", error);
        toast.error("Error saving data!", { autoClose: 3000 });
      }
    },
  });

  const deleteItem = (pk_process_key) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This process will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/deleteProcess/process/`,
            { pk_process_key }
          );
          Swal.fire("Deleted!", "Process deleted successfully", "success");
          toast.success("Deleted successfully!", { autoClose: 3000 });
          fetchProcess(selectedFarmKey);
        } catch (error) {
          Swal.fire("Error!", "Failed to delete process", "error");
        }
      }
    });
  };


  const closeModal = () => {
    setmodal_center(false);
    setEditModal(false);
    setEditingItem(null);
    setImagePreview(null);
    formik.resetForm();
  };

  const handleEdit = async (pk_process_key) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getProcess/process/`,
        { pk_process_key }
      );

      const item = response.data?.message?.data;

      if (item) {
        setOldImagePath(item.process_image || null);
        setEditingItem(item);

        setImagePreview(
          item.process_image
            ? `${process.env.REACT_APP_IMAGE_URL}${item.process_image}`
            : null
        );

        formik.setValues({
          title: item.process_name || "",
          description: item.process_description || "",
          // duration: item.process_duration || "",
          day: item.pk_process_day_key || item.process_day || "",
          image: null,
        });

        setEditModal(true);
      } else {
        console.warn("No data found");
      }
    } catch (err) {
      console.error(
        "Error fetching process:",
        err.response?.data || err.message
      );
    }
  };


  const data = {
    columns: [
      { label: "S.No", field: "sno", sort: "asc", width: 50 },
      { label: "Process Name", field: "Process Name", sort: "asc", width: 150 },
      { label: "Description", field: "Description", sort: "asc", width: 200 },
      {
        label: "Process Image",
        field: "Process Image",
        sort: "asc",
        width: 120,
      },
      // { label: "Duration", field: "Duration", sort: "asc", width: 120 },
      { label: "Day", field: "Day", sort: "asc", width: 150 },
      { label: "Actions", field: "actions", sort: "disabled", width: 100 },
    ],
    rows: rows.map(row => (({
      ...row,
      actions: (
        <Dropdown
          isOpen={openDropdown === row.id}
          toggle={() => toggleDropdown(row.id)}
        >
          <DropdownToggle
            tag="button"
            className="btn btn-link text-muted p-0 border-0 shadow-none"
          >
            <i className="mdi mdi-dots-vertical fs-5"></i>
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem
              onClick={() => {
                const pkKey = row.pk_process_key || row.pk_process_key;
                handleEdit(pkKey);
              }}
            >
              <i className="mdi mdi-pencil-outline me-2"></i> Edit
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem className="text-danger"
              onClick={() => {
                const pkKey = row.pk_process_key || row.pk_process_key;
                deleteItem(pkKey);
              }}>
              <i className="mdi mdi-delete-outline me-2"></i> Delete Process
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )
    }))),
  }


  // const rows = [
  //   {
  //     id: 1,
  //     sno: "1",
  //     "Process Name": "Substrate Preparation",
  //     Description:
  //       "Chopping, soaking, and pasteurizing straw substrate for bag filling.",
  //     "Process Image": (
  //       <img src={substrateImg} alt="Substrate Preparation" width="80" />
  //     ),
  //     Duration: "2 Days",
  //     Day: "Day 0 - Day 2",
  //   },
  //   {
  //     id: 2,
  //     sno: "2",
  //     "Process Name": "Inoculation",
  //     Description:
  //       "Mixing mushroom spawn into the cooled substrate and sealing the bags.",
  //     "Process Image": <img src={Inoculation} alt="Inoculation" width="80" />,
  //     Duration: "1 Day",
  //     Day: "Day 3",
  //   },
  //   {
  //     id: 3,
  //     sno: "3",
  //     "Process Name": "Fruiting",
  //     Description:
  //       "Transferring bags to a light and humid environment for fruiting.",
  //     "Process Image": <img src={fruitingImg} alt="Fruiting" width="80" />,
  //     Duration: "7 Days",
  //     Day: "Day 19 - Day 26",
  //   },
  // ]

  const fetchFarms = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/getAllFarms/farm/`
      );

      const resData = response.data;
      setIsLoading(false);

      if (resData.message?.success && Array.isArray(resData.message.data)) {
        setFarmList(resData.message.data);

        // Auto-select farm id=1 from list
        const defaultFarm = resData.message.data.find(f => f.pk_farm_id == 1);
        if (defaultFarm) {
          setSelectedFarmKey(defaultFarm.pk_farm_key);
        }
      } else {
        console.warn("Unexpected data format", resData);
        setFarmList([]);
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      setIsLoading(false);
      setFarmList([]);
      toast.error("Failed to fetch!", { autoClose: 3000 });
    }
  };

  useEffect(() => {
    if (selectedFarmKey) {
      fetchProcess
        (selectedFarmKey);
    }
  }, [selectedFarmKey]);


  return (
    <React.Fragment>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <Breadcrumb />

        <div className="d-flex align-items-center">
          <div className="mt-2 me-3" style={{ minWidth: "250px" }}>
            <select
              className="form-select"
              value={selectedFarmKey}
              onChange={(e) => setSelectedFarmKey(e.target.value)}
            >
              <option value="">-- Select Farm --</option>
              {farmList.map((farm) => (
                <option key={farm.pk_farm_key} value={farm.pk_farm_key}>
                  {farm.farm_name}
                </option>
              ))}
            </select>
          </div>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={tog_center}
          >
            <i className="mdi mdi-plus me-1"></i>
            Add New Process
          </Button>
        </div>
      </div>

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <MDBDataTable
                responsive
                striped
                bordered
                data={data}
                noBottomColumns
              />
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Add New Process Modal */}
      <Modal isOpen={modal_center} toggle={tog_center} centered={true}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add New Process</h5>
          <button
            type="button"
            onClick={() => setmodal_center(false)}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          <Row>
            <Col lg={12}>
              <Form onSubmit={formik.handleSubmit}>

                <div className="mb-3">
                  <label htmlFor="process-name" className="form-label">
                    Process Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="process-name"
                    name="title"
                    placeholder="Enter process name"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.title && formik.errors.title ? (
                    <div className="text-danger mt-1">{formik.errors.title}</div>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label htmlFor="process-description" className="form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    id="process-description"
                    name="description"
                    rows="3"
                    placeholder="Enter short description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  ></textarea>
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-danger mt-1">{formik.errors.description}</div>
                  ) : null}
                </div>

                {/* <div className="mb-3">
                  <label htmlFor="process-duration" className="form-label">
                    Duration <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="process-duration"
                    name="duration"
                    placeholder="e.g., 2 Days, 1 Week"
                    value={formik.values.duration}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.duration && formik.errors.duration ? (
                    <div className="text-danger mt-1">{formik.errors.duration}</div>
                  ) : null}
                </div> */}

                <div className="mb-3">
                  <label htmlFor="process-day" className="form-label">
                    Choose Day <span className="text-danger">*</span>
                  </label>

                  <select
                    id="process-day"
                    name="day"
                    className="form-control"
                    value={formik.values.day}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">-- Select Process Day --</option>

                    {processDays.map((day) => (
                      <option key={day.pk_process_day_key} value={day.pk_process_day_key}>
                        {day.process_day}
                      </option>
                    ))}
                  </select>
                  {formik.touched.day && formik.errors.day ? (
                    <div className="text-danger mt-1">{formik.errors.day}</div>
                  ) : null}
                </div>


                <div className="mb-3">
                  <label htmlFor="process-image" className="form-label">
                    Process Image
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    id="process-image"
                    name="image"
                    accept="image/*"
                    onChange={(e) => {
                      formik.setFieldValue("image", e.currentTarget.files[0]);
                      // preview optional
                      if (e.currentTarget.files[0]) {
                        setImagePreview(URL.createObjectURL(e.currentTarget.files[0]));
                      } else {
                        setImagePreview(null);
                      }
                    }}
                  />

                </div>

                <div className="mt-4 text-end">

                  <button type="button" className="btn btn-primary w-md" onClick={closeModal} style={{ marginRight: "2px" }}>
                    Cancel
                  </button>

                  <button type="submit" className="btn btn-primary w-md">
                    Submit
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* Edit Process Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(!editModal)} centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Edit Process</h5>
          <button
            type="button"
            onClick={() => { setEditModal(false); setEditingItem(null); formik.resetForm(); }}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Process Name <span className="text-danger">*</span></label>
              <input
                className="form-control"
                type="text"
                name="title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.title && formik.errors.title ? (
                <div className="text-danger mt-1">{formik.errors.title}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label">Description <span className="text-danger">*</span></label>
              <textarea
                className="form-control"
                rows="3"
                name="description"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              ></textarea>
              {formik.touched.description && formik.errors.description ? (
                <div className="text-danger mt-1">{formik.errors.description}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label">Duration <span className="text-danger">*</span></label>
              <input
                className="form-control"
                type="text"
                name="duration"
                value={formik.values.duration}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.duration && formik.errors.duration ? (
                <div className="text-danger mt-1">{formik.errors.duration}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label">Choose Day <span className="text-danger">*</span></label>
              <select
                className="form-control"
                name="day"
                value={formik.values.day}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">-- Select Process Day --</option>
                {processDays.map((day) => (
                  <option key={day.pk_process_day_key} value={day.pk_process_day_key}>
                    {day.process_day}
                  </option>
                ))}
              </select>
              {formik.touched.day && formik.errors.day ? (
                <div className="text-danger mt-1">{formik.errors.day}</div>
              ) : null}
            </div>

            {/* <div className="mb-3">
              <label className="form-label">Update Process Image</label>
              <input
                className="form-control"
                type="file"
                name="image"
                accept="image/*"
                onChange={(e) => {
                  formik.setFieldValue("image", e.currentTarget.files[0]);
                  if (e.currentTarget.files[0]) {
                    setImagePreview(URL.createObjectURL(e.currentTarget.files[0]));
                  }
                }}
              />
              {imagePreview && (
                <div style={{ marginTop: 8 }}>
                  <img src={imagePreview} alt="preview" width="120" />
                </div>
              )}
            </div> */}
            <div className="mb-3">
              <label className="form-label">Process Image</label>

              <div style={{ display: "flex", flexDirection: "column" }}>
                {imagePreview && (
                  <div style={{ position: "relative", width: "140px" }}>
                    <img
                      src={imagePreview}
                      alt="preview"
                      width="140"
                      style={{
                        borderRadius: 6,
                        border: "1px solid #ccc",
                        display: "block",
                      }}
                    />

                    <button
                      type="button"
                      onClick={() => {
                        setImagePreview(null);
                        formik.setFieldValue("image", null);
                        setOldImagePath(null);
                      }}
                      style={{
                        position: "absolute",
                        top: "-6px",
                        right: "-6px",
                        background: "#ff4d4f",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "22px",
                        height: "22px",
                        cursor: "pointer",
                        fontSize: "12px",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}

                {!imagePreview && (
                  <input
                    className="form-control mt-2"
                    type="file"
                    accept="image/*"
                    name="image"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      formik.setFieldValue("image", file);
                      if (file) {
                        setImagePreview(URL.createObjectURL(file));
                      }
                    }}
                  />
                )}
              </div>
            </div>



            <div className="mt-4 text-end">
              <button type="button" className="btn btn-primary w-md" onClick={closeModal} style={{ marginRight: "2px" }}>
                Cancel
              </button>
              <Button type="submit" className="btn  w-md" color="primary">
                Save Changes
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
